export const customerTableConfig = {
  propList: [
    {prop: 'uname', label: '客户昵称', minWidth: '80', align: 'left', slotName: 'consumer'},
    {prop: 'thirdParty', label: '所属第三方', minWidth: '60'},
    {prop: 'sourceLabel', label: '来源', minWidth: '60'},
    {prop: 'createdAt', label: '加入时间', minWidth: '80'},
    {prop: 'deletedAt', label: '删除时间', minWidth: '80'}
  ]
}
